import FunctionsLogo from '~/assets/drill/functions'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function Functions({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-17 row-end-19 col-start-1 col-end-3'
  const gridTablet = 'md:row-start-4 md:row-end-5 md:col-start-4 md:col-end-6'
  const gridDesktop = 'xl:row-start-3 xl:row-end-3 xl:col-start-5 xl:col-end-7'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={FunctionsLogo}
      imageClassNames="h-16"
      path={path}
      title={title}
    />
  )
}
